import React from 'react';
import './index.css';

export default function ProgressBar({
  title,
  count,
  total,
  isPercentage = true,
  isProgressBar = true,
  icon,
  customTitleClass,
}) {
  const percentage =
    count !== undefined && count > 0 ? ((count / total) * 100).toFixed(2) : 0;

  const heading = () => {
    if (isPercentage) {
      return (
        <div className="progress-bar-heading">
          <div className={customTitleClass || "title"} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {icon && <img src={icon} alt="" style={{ width: '20px', height: '20px' }} />}
            {title}
          </div>
          <div className={customTitleClass || "title"}>{percentage}%</div>
        </div>
      );
    }
    return (
      <div className="ratio-bar-heading">
        <div className="ration-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {icon && <img src={icon} alt="" style={{ width: '20px', height: '20px' }} />}
          {title}
        </div>
        <div className="ration-number">
          {count} of {total}
        </div>
      </div>
    );
  };
  return (
    <div className="progress-bar-container">
      {heading()}
      {isProgressBar && (
        <div className="progress-container">
          <div className="progress-bar" style={{ width: `${percentage}%` }}></div>
        </div>
      )}
    </div>
  );
}
